/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import {
  Box,
  Card,
  CardContent,
  FormControl,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import axios from "axios";
import { getColorMappings } from "components/ColorComponent/ColorComponent";
import TimelineItem from "components/Icon/TimelineItem";
import LoadingModal from "components/LoadingModel/loadingModal";
import MDButton from "components/MDButton";
import { useMaterialUIController } from "context";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import PageTitle from "examples/PageTitle/PageTitle";
import { useEffect, useState } from "react";
import DataTable, { createTheme } from "react-data-table-component";
import { Link, useParams } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { appConstants } from "utils/appConstants";
const pdfStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%", // increase the width
  height: "90%x", // increase the height
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

createTheme(
  "solarized",
  {
    text: {
      primary: "white",
      secondary: "white",
    },
    background: {
      default: "#202940",
    },
    context: {
      background: "#202940",
      text: "white",
    },
    divider: {
      default: "white",
    },
    sortFocus: {
      default: "#2aa198",
    },
  },
  "dark"
);
createTheme(
  "light",
  {
    text: {
      primary: "black",
      secondary: "black",
    },
    background: {
      default: "white",
    },
    context: {
      background: "white",
      text: "black",
    },
    divider: {
      default: "gray",
    },
    sortFocus: {
      default: "#2aa198",
    },
  },
  "dark"
);



function ViewInvoices() {

  //Starts here change the pagination text Rows per page to Record per page
  let changePaginationText = document.getElementsByClassName("rdt_Pagination")[0];
  if (changePaginationText !== undefined) {
    changePaginationText.getElementsByTagName("span")[0].textContent = "Records Per Page";
  }  //ends here change the pagination text Rows per page to Record per page

  const { id: InvoiceID } = useParams();
  const [viewDocumentInModal, setViewDocumentInModal] = useState(false);
  const [controller] = useMaterialUIController();
  const { darkMode, sidenavColor } = controller;
  const { barColor, tableBorder } = getColorMappings(sidenavColor);
  const [loading, setLoading] = useState(false);

  const [showInvoiceSection, setShowInvoiceSection] = useState(false);
  const [itemRowValues, setItemRowValues] = useState([
    {
      itemName: "", itemPrice: "", itemQuantity: "", gst: "", priceValidity: "None",
      priceValidityValue: "", discountType: "None", discountValue: "", discountAmount: ""
    },
  ]);
  const [getDocumentFileURL, setSetDocumentFileURL] = useState('');
  const [values, setValues] = useState({
    quotationID: undefined,
    invoiceID: "",
    invoiceNumber: 'Auto Generated',
    contactID: '',
    purchaseOrderNumber: '',
    invoiceDate: new Date(),
    validUpto: "Same Day",
    validUptoDate: new Date(),
    invoiceStatus: 'Unpaid',
    gstType: "Inclusive",
    totalAmount: 0,
    totalDiscountAmount: 0,
    finalAmount: 0,
    paymentInstruction: '',
  })
  const [quoDocuments, setDocuments] = useState([]);


  useEffect(() => {
    const fetchData = async () => {
      await FetchPendingInvoiceForCustomer();
    };
    fetchData();
  }, []);




  const FetchPendingInvoiceForCustomer = async () => {
    setLoading(true)
    await axios.post(appConstants.baseURL + 'invoice/viewInvoiceByID', { invoiceID: InvoiceID }).then(res => {
      if (res.data.Result_Status) {
        let data = res.data.Result_Output;

        setShowInvoiceSection(true);
        data.length > 0 && setValues(data[0]);
        data[0].itemsList.length > 0 && setItemRowValues(data[0].itemsList);
        data[0].documentsList.length > 0 && setDocuments(data[0].documentsList);
      } else {
        console.log("Error in fetchPendinginvoiceForCustomer: ", res.data.Result_Message);
      }
      setLoading(false);
    }).catch(error => {
      console.error("Error in fetchPendinginvoiceForCustomer: ", error);
    })
  }

  const customStyles = {
    table: {
      style: {
        borderColor: tableBorder,
      },
    },
    headRow: {
      style: {
        color: darkMode ? "white" : "white",
        background: barColor,
      },
    },
    headCells: {
      style: {
        paddingLeft: "10px",
        paddingRight: "10px",
        fontWeight: "bold",
        fontSize: "14px",
        color: "white",
      },
    },
  };

  let columns = [
    {
      name: "Item Name",
      selector: (row, i) => (
        <TextField
          type="text"
          value={row.itemName}
          variant="outlined"
          disabled
          fullWidth
          inputProps={{
            className: "custom-fieldtext",
            maxLength:200
          }}
        />

      ),
      style: {
        paddingLeft: "10px",
        paddingTop: "10px",
        paddingRight: "10px",
        paddingBottom: "10px",
        display: "block"
      },
    },
    {
      name: "Item Price",
      selector: (row, i) => (
        <TextField
          type="text"
          value={row.itemPrice}
          variant="outlined"
          disabled
          fullWidth
          inputProps={{
            className: "custom-fieldtext"
          }}

        />
      ),
      center: true,
      style: {
        paddingLeft: "10px",
        paddingTop: "10px",
        paddingRight: "10px",
        paddingBottom: "10px",
      },
    },
    {
      name: "Item Quantity",
      selector: (row, i) => (
        <TextField
          type="text"
          autoComplete="off"
          value={row.itemQuantity}
          variant="outlined"
          disabled
          fullWidth
          inputProps={{
            className: "custom-fieldtext"
          }}

        />
      ),
      center: true,
      style: {
        paddingLeft: "10px",
        paddingTop: "10px",
        paddingRight: "10px",
        paddingBottom: "10px",
      },
    },
    {
      name: "GST%",
      selector: (row, i) => (
        <TextField
          type="text"
          autoComplete="off"
          variant="outlined"
          fullWidth
          value={row.gst}
          disabled
          style={{ cursor: 'default', pointerEvents: 'none' }}
          inputProps={{
            className: "custom-fieldtext"
          }}

        />
      ),
      center: true,
      style: {
        paddingLeft: "10px",
        paddingTop: "10px",
        paddingRight: "10px",
        paddingBottom: "10px",
      },
    },
    {
      name: "Discount Type",
      selector: (row, i) => (
        <Select
          style={{ height: "35.11px" }}
          labelId="day-hours-select-label"
          id="day-hours-select"
          value={row.discountType}
          disabled
          fullWidth
          variant="outlined"
        >
          <MenuItem value="None">None</MenuItem>
          <MenuItem value="Percentage">Percentage %</MenuItem>
          <MenuItem value="Fixed">Fixed</MenuItem>
        </Select>
      ),
      center: true,
      style: {
        paddingLeft: "10px",
        paddingTop: "10px",
        paddingRight: "10px",
        paddingBottom: "10px", display: "block"
      },
    },
    {
      name: "Discount Value",
      selector: (row, i) => (
        <TextField
          type="text"
          autoComplete="off"
          variant="outlined"
          fullWidth
          value={row.discountType === "None" ? 0 : row.discountValue}
          disabled
          inputProps={{
            className: "custom-fieldtext"
          }}

        />
      ),
      center: true,
      style: {
        paddingLeft: "10px",
        paddingTop: "10px",
        paddingRight: "10px",
        paddingBottom: "10px",
      },
    },
    {
      name: "Discount Amount($)",
      selector: (row, i) => (
        <TextField
          type="text"
          autoComplete="off"
          variant="outlined"
          fullWidth
          value={row.discountType === "None" ? 0 : row.discountAmount}
          disabled
          inputProps={{
            className: "custom-fieldtext"
          }}

        />
      ),
      center: true,
      style: {
        paddingLeft: "10px",
        paddingTop: "10px",
        paddingRight: "10px",
        paddingBottom: "10px",
      },
    },

  ];

  const handleViewDocument = (selectedDocRow) => {
    setSetDocumentFileURL(appConstants.baseURL + 'quotation/viewUploadedQuotationDocument?fileName=/' + selectedDocRow.documentFileName);
    setViewDocumentInModal(true);
  };


  const documentColumns = [
    {
      name: "Document Name",
      selector: (row) => row.documentName,
      sortable: true,
      sortField: "name",
      style: { paddingLeft: "10px" },
    },
    {
      name: "Action",
      selector: (row) => row,
      center: true,
      cell: (row) => (
        <>
          <Grid item mt={-3}>
            <TimelineItem
              color="info"
              icon="visibility"
              onClick={() => { handleViewDocument(row) }}
              title="View"
            />
          </Grid>


        </>
      ),
    },
  ];

  const paginationComponentOptions = {
    selectAllRowsItem: false,
  };


  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div style={{ marginTop: "20px" }}>
        <Card color="primary" sx={{ pb: "10px" }}>

          <PageTitle screenName={`View Debt (${values.invoiceStatus})`} />
          <Grid container px={2} mt={2} spacing={2}>
            {/* invoice Number */}
            <Grid item lg={3} xs={6}>
              <TextField
                type="text"
                label="Invoice Number"
                variant="outlined"
                disabled
                fullWidth
                value={values.invoiceNumber}
                inputProps={{
                  className: "custom-fieldtext"
                }}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            {/* contact Name Dropdown */}
            <Grid item lg={3} xs={6}>
              <TextField
                type="text"
                label="Customer"
                variant="outlined"
                disabled
                fullWidth
                value={values.contactName}
                inputProps={{
                  className: "custom-fieldtext"
                }}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            {/* Reference Number */}
            <Grid item lg={3} xs={6}>
              <TextField
                type="text"
                label="Reference Number "
                variant="outlined"
                placeholder="Optional"
                fullWidth
                value={values.purchaseOrderNumber}
                inputProps={{
                  className: "custom-fieldtext",
                  maxLength: 50
                }}
                InputLabelProps={{ shrink: true }}

                disabled
              />
            </Grid>
            <Grid item lg={3} xs={6}>
              <TextField
                type="text"
                label="Invoice Date"
                variant="outlined"
                fullWidth
                value={values.invoiceDate}
                inputProps={{
                  className: "custom-fieldtext"
                }}
                InputLabelProps={{ shrink: true }}
                disabled
              />
            </Grid>

            {/* validUpto */}
            <Grid item lg={3} xs={6}>
              <TextField
                type="text"
                label="Due Upto"
                variant="outlined"
                fullWidth
                value={values.dueUpto}
                inputProps={{
                  className: "custom-fieldtext"
                }}
                InputLabelProps={{ shrink: true }}
                disabled
              />
            </Grid>

            <Grid item lg={3} xs={6}>
              <TextField
                type="text"
                label="Due Date"
                variant="outlined"
                fullWidth
                value={values.dueDate}
                inputProps={{
                  className: "custom-fieldtext"
                }}
                InputLabelProps={{ shrink: true }}
                disabled
              />
            </Grid>
            <Grid item lg={3} xs={6}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Status</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  style={{ height: "35.11px" }}
                  disabled
                  label="Status"
                  value={values.invoiceStatus}

                >
                  <MenuItem value="Unpaid">Unpaid</MenuItem>
                  <MenuItem value="Paid">Paid</MenuItem>
                </Select>
              </FormControl>
            </Grid>

          </Grid>
          <CardContent>
            <DataTable
              theme={darkMode ? "solarized" : "light"}
              columns={columns}
              data={itemRowValues}
              customStyles={customStyles}
              fixedHeaderScrollHeight="210px"
              fixedHeader={true}
            />
          </CardContent>
          <Grid container px={2} pt={2} pb={2} spacing={2}>
            <Grid item lg={3} xs={12}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">GST Type</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  style={{ height: "35.11px" }}
                  label="GST Type"
                  value={values.gstType || 'Inclusive'}
                  disabled
                >
                  <MenuItem value="Inclusive">Inclusive</MenuItem>
                  <MenuItem value="Exclusive">Exclusive</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item lg={3} xs={12}>
              <TextField
                type="text"
                label="Total Amount($)"
                variant="outlined"
                fullWidth
                inputProps={{
                  className: "custom-fieldtext"
                }}
                InputLabelProps={{ shrink: true }}
                disabled
                value={values.totalAmount}

              />
            </Grid>
            <Grid item lg={3} xs={12}>
              <TextField
                type="text"
                label="Total Discount Amount($)"
                variant="outlined"
                fullWidth
                inputProps={{
                  className: "custom-fieldtext"
                }}
                InputLabelProps={{ shrink: true }}
                disabled
                value={values.totalDiscountAmount}

              />
            </Grid>
            <Grid item lg={3} xs={12}>
              <TextField
                type="text"
                label="Final Amount($)"
                variant="outlined"
                fullWidth
                inputProps={{
                  className: "custom-fieldtext"
                }}
                InputLabelProps={{ shrink: true }}
                disabled
                value={values.finalAmount}

              />
            </Grid>

            <Grid item lg={12} xs={12}>
              <TextField
                type="text"
                label="Payment Instructions"
                variant="outlined"
                fullWidth
                value={values.paymentInstruction}
                disabled

              />
            </Grid>


          </Grid>
          {/* Doc Table only visible if doc Array have data */}
          {quoDocuments.length > 0 &&
            <CardContent>
              <DataTable
                theme={darkMode ? "solarized" : "light"}
                columns={documentColumns}
                data={quoDocuments}
                fixedHeaderScrollHeight="210px"
                fixedHeader={true}
                customStyles={customStyles}
              />
            </CardContent>
          }

          {values.invoiceStatus === "Paid" && <>
            <Grid item px={2} pt={1} xs={12} md={4} lg={12} mt={2} >
              <p style={{ fontSize: "14px", fontWeight: "bold", color: "#008000" }} >Invoice Payment Details</p>
            </Grid>
            <Grid container px={2} mt={2} spacing={2} mb={2}>
              <Grid item lg={3} xs={6}>
                <TextField
                  type="text"
                  label="Payment Date"
                  variant="outlined"
                  placeholder="Optional"
                  fullWidth
                  disabled
                  InputLabelProps={{ shrink: true }}
                  value={values.paymentDate}
                />
              </Grid>
              <Grid item lg={3} xs={6}>
                <TextField
                  type="text"
                  label="Payment Mode"
                  variant="outlined"
                  placeholder="Payment Mode"
                  fullWidth
                  disabled
                  InputLabelProps={{ shrink: true }}
                  value={values.paymentMode}

                />
              </Grid>
              <Grid item lg={3} xs={6}>
                <TextField
                  type="text"
                  label="Transaction ID"
                  variant="outlined"
                  placeholder="Transaction ID"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  disabled
                  value={values.paymentTransactionID}

                />
              </Grid>
              <Grid item lg={3} xs={6}>
                <TextField
                  type="text"
                  label={`Payment Amount (${values.currencyValue})`}
                  variant="outlined"
                  placeholder={`Payment Amount (${values.currencyValue})`}
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  disabled
                  value={`(${values.currencyValue}) ${values.finalAmount}`}
                />
              </Grid>
            </Grid>
          </>}
          <Grid
            container
            mt={2}
            pb={3}
            columnSpacing={4}
            alignItems="center"
            display="flex"
            justifyContent="center"
          >
            <Link to="/debts">
              <Grid item xs={12} md={4} spacing={2} lg={1.8}>
                <MDButton
                  className="btn-block center-container-btn btn-warning btn-back rightSpace"
                  color="warning"
                  fullWidth
                >
                  Close
                </MDButton>
              </Grid>
            </Link>
          </Grid>
        </Card>
      </div>

      <Modal
        open={viewDocumentInModal}
        onClose={() => setViewDocumentInModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{
          '& .MuiModal-root': {
            width: '100%',
            height: '100%',
          },
        }}
      >
        <Card sx={pdfStyle}>
          <Box>
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
            >
              Invoice Document Viewer
            </Typography>
            <iframe title="Invoice Document Viewer" src={getDocumentFileURL} width="100%" height="650" frameborder="0" allowfullscreen={true}></iframe>

            <Grid container id="modal-modal-description" sx={{ mt: 2, justifyContent: "center" }}>
              <MDButton color="warning" className="modalButton" onClick={() => { setViewDocumentInModal(false) }}>

                Close
              </MDButton>
            </Grid>
          </Box>
        </Card>
      </Modal>
      <LoadingModal loading={loading} />

    </DashboardLayout>
  );
}

export default ViewInvoices;
